import Vue from 'vue'
import Router from 'vue-router'

import maincontent from '@/components/main_content.vue'
import wiki from '@/components/wiki/frame.vue'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      component: maincontent,
      children: [

      ]
    },
    {
      path: '/wiki',
      name: 'wiki',
      component: wiki
    }
  ]
})

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js